import Routes from '../helpers/Routes';
import {
  IGenerateInvoiceParams,
  IMarkAsPaidParams,
  IProfessionalInvoiceParams,
  IRatePharmacyParams,
} from '../models';

import httpClient from './httpClient';

const { professionalBasePath, rate, rating, ratingItems, invoices } =
  Routes.professional;
class ProfessionalController {
  basePath: string;

  constructor() {
    this.basePath = professionalBasePath;
  }

  ratingItems = (pharmacyId: string) =>
    httpClient.get(`${this.basePath}${ratingItems}/${pharmacyId}`);

  rate = (params: IRatePharmacyParams) =>
    httpClient.post(`${this.basePath}${rate}`, { model: params });

  rating = (pharmacyId: string) =>
    httpClient.get(`${this.basePath}${rating}/${pharmacyId}`);

  getBookedRating = (bookingId: string) =>
    httpClient.get(`${this.basePath}${rate}/${bookingId}`);

  getProfessionalInvoice = (params: IProfessionalInvoiceParams) =>
    httpClient.post(`${this.basePath}${Routes.professional.invoices}`, params);

  generateProfessionalInvoice = (params: IGenerateInvoiceParams) =>
    httpClient.post(
      `${this.basePath}${Routes.professional.invoices}/${Routes.general.generate}`,
      { model: params }
    );

  markAsPaid = (params: IMarkAsPaidParams) =>
    httpClient.post(
      `${this.basePath}${Routes.general.bookings}/${Routes.professional.markPaid}`,
      params
    );
}

export default new ProfessionalController();
